/* tslint:disable:typedef-whitespace */
/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {WorkType, WorkBlock} from '@/models/scenario/work.block';
import {ICommand}            from '@/util/i.command';
import {WorkBloxEditor}      from './work.blox.editor';

/**
 *
 * @class SetTypeCommand
 *
 * @brief reversible updates of the type column
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class SetTypeCommand implements ICommand {

  private oldValue: WorkType;
  private newValue: WorkType;
  private editor:   WorkBloxEditor;

  constructor(oldValue: WorkType, newValue: WorkType, editor: WorkBloxEditor) {

    this.oldValue = oldValue;
    this.newValue = newValue;
    this.editor   = editor;
  }

  /** effect the command */
  execute() {

    this.editor.setType(this.newValue);
  }

  /** reverse the command's effects */
  unExecute() {

    this.editor.setType(this.oldValue);
  }

  /** return a string summary of this command */
  asString(): string {

    return '[type] ' + WorkBlock.typeToString(this.oldValue) + ' => ' +
           WorkBlock.typeToString(this.newValue);
  }

}
